module.exports = __webpack_public_path__ + "img/certificadoM2.f4643f9b.png";